module.exports = __webpack_public_path__ + "static/media/search_icon.1609ae47.svg";